<template>
  <span class="message-renderer">
    <slot>{{ message }}</slot>
  </span>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    message?: string;
  }>(),
  {
    message: "",
  },
);
</script>

<style lang="scss" scoped>
.message-renderer {
  white-space: pre-wrap;
}
</style>
